import { ICartData } from '@features/cart/typescript';
const TikTokAddToCart = (products: ICartData[]) => {
  products.forEach((product: ICartData) => {
    if (window?.ttq?.track && typeof window.ttq.track === 'function') {
      window.ttq.track('viewProduct', {
        content_name: product?.name,
        content_id: product?.productId
      });
    }
  });
};
export default TikTokAddToCart;